import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-typography",
  templateUrl: "./med-icon-typography.component.html",
})
export class MedIconTypographyComponent extends SvgMixinComponent {}
